/**
 * Конфигурация рекламного баннера
 * 
 * ИНСТРУКЦИЯ ДЛЯ РАЗМЕЩЕНИЯ РЕКЛАМНОГО БАННЕРА:
 * 
 * 1. ПОДГОТОВКА ИЗОБРАЖЕНИЯ:
 *    - Формат: JPG, PNG или SVG
 *    - Рекомендуемые размеры:
 *      * 728x90 пикселей (стандартный горизонтальный баннер)
 *      * 300x250 пикселей (боковой баннер)
 *      * 320x100 пикселей (мобильный баннер)
 *    - Максимальный размер файла: 200KB
 *    - Изображение должно быть оптимизировано для веба
 * 
 * 2. РАЗМЕЩЕНИЕ ИЗОБРАЖЕНИЯ:
 *    - Поместите изображение баннера в папку: public/images/banners/
 *    - Или используйте внешнюю ссылку (URL)
 * 
 * 3. НАСТРОЙКА БАННЕРА:
 *    - enabled: true/false - включить/выключить баннер
 *    - imageUrl: путь к изображению (относительный от public/ или полный URL)
 *    - linkUrl: ссылка, на которую будет вести баннер (опционально)
 *    - altText: альтернативный текст для изображения
 *    - width: ширина баннера (например, '728px' или '100%')
 *    - height: высота баннера (например, '90px' или 'auto')
 *    - backgroundColor: цвет фона вокруг баннера
 *    - openInNewTab: открывать ссылку в новой вкладке (true/false)
 * 
 * ПРИМЕРЫ:
 * 
 * Пример 1: Локальное изображение
 * {
 *   enabled: true,
 *   imageUrl: '/images/banners/ad-banner.jpg',
 *   linkUrl: 'https://example.com',
 *   altText: 'Рекламний банер',
 *   width: '728px',
 *   height: '90px',
 *   openInNewTab: true,
 * }
 * 
 * Пример 2: Внешнее изображение
 * {
 *   enabled: true,
 *   imageUrl: 'https://example.com/banner.jpg',
 *   linkUrl: 'https://example.com',
 *   altText: 'Рекламний банер',
 *   openInNewTab: true,
 * }
 * 
 * Пример 3: Баннер без ссылки
 * {
 *   enabled: true,
 *   imageUrl: '/images/banners/info-banner.png',
 *   altText: 'Інформаційний банер',
 * }
 * 
 * Пример 4: Баннер с отдельными версиями для десктопа и мобильных
 * {
 *   enabled: true,
 *   imageUrl: '/images/banners/ad-banner-desktop.jpg',      // 728x90 для десктопа
 *   mobileImageUrl: '/images/banners/ad-banner-mobile.jpg',  // 320x100 для мобильных
 *   linkUrl: 'https://example.com',
 *   altText: 'Рекламний банер',
 *   openInNewTab: true,
 * }
 */

export const adBannerConfig = {
  // Включить/выключить баннер
  enabled: true,

  // Путь к изображению баннера для десктопа
  // Варианты:
  // - Относительный путь от папки public: '/images/banners/ad-banner.jpg'
  // - Полный URL: 'https://example.com/banner.jpg'
  imageUrl: '/images/banners/720x90.jpg',

  // Путь к изображению баннера для мобильных устройств (опционально)
  // Если не указано, будет использоваться imageUrl для всех устройств
  // Рекомендуемый размер: 320x100 или 300x250 пикселей
  mobileImageUrl: '/images/banners/320x100.jpg',

  // Ссылка, на которую будет вести баннер (опционально)
  // Если не указана, баннер будет просто изображением без ссылки
  linkUrl: 'http://www.realmusic.ua/',

  // Альтернативный текст для изображения (для доступности и SEO)
  altText: 'РЕАЛМЮЗІК - знижка 10% на музичні інструменти та обладнання за промокодом MUSIC',

  // Размеры баннера (опционально)
  // Можно указать конкретные размеры или 'auto' для автоматического размера
  // Для лучшего качества рекомендуется использовать реальные размеры изображения
  width: 'auto', // например: '720px', '100%', 'auto' (auto = использует реальный размер изображения)
  height: 'auto', // например: '90px', 'auto' (auto = сохраняет пропорции)

  // Цвет фона вокруг баннера (опционально)
  backgroundColor: '#f5f5f5',

  // Открывать ссылку в новой вкладке (true/false)
  openInNewTab: true,
};
